/**
 * Created by mgoria on 09/01/15.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LocalToken = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Token2 = require('./Token');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Security token holds details about logged user
 */
let LocalToken = exports.LocalToken = function (_Token) {
  _inherits(LocalToken, _Token);

  /**
   * @param {Array} args
   */
  function LocalToken() {
    var _ref;

    _classCallCheck(this, LocalToken);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(this, (_ref = LocalToken.__proto__ || Object.getPrototypeOf(LocalToken)).call.apply(_ref, [this].concat(args)));
  }

  /**
   * @param {Function} callback
   */


  _createClass(LocalToken, [{
    key: 'loadCredentials',
    value: function loadCredentials() {
      let callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : () => {};


      // fake local credentials
      this._credentialsManager.systemCredentials = {
        expireTime: Date.now() + 86400000,
        // use provider user id or a fake userId instead of cognito identity id for local backend
        identityId: this.identityProvider && this.identityProvider.userId ? this.identityProvider.userId : 'us-east-1:xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx'
      };

      callback(null, this._credentials);
    }

    /**
     * @returns {Boolean}
     */

  }, {
    key: 'getUser',


    /**
     * @param {Function} callback
     */
    value: function getUser(callback) {
      // @todo: backward compatibility hook, remove on next major release
      let argsHandler = (error, user) => {
        if (callback.length === 1) {
          if (error) {
            throw error;
          }

          return callback(user);
        }

        callback(error, user);
      };

      this._loadUser(argsHandler);
    }

    /**
     * 'Reset' credentials
     */

  }, {
    key: 'destroy',
    value: function destroy() {
      this._credentials = null;
      this._credsManager = null;
    }
  }, {
    key: 'isAnonymous',
    get: function get() {
      if (this.lambdaContext) {
        return this.lambdaContext.identity.isAnonymous;
      } else {
        return !this.identityProvider;
      }
    }
  }]);

  return LocalToken;
}(_Token2.Token);


//////////////////
// WEBPACK FOOTER
// ../~/deep-security/lib.compiled/LocalToken.js
// module id = 449
// module chunks = 0